import React from 'react';
import cx from 'classnames';
import { Button } from 'antd';
import type { BillingStepKey } from '../../steps';
import { renderSectionView, SectionViewOpts } from '../../reviewSpec';
import s from './s.module.less';

const AttentionIcon = () => (
    <svg width="14" height="14" viewBox="0 0 20 20" fill="#92400E" aria-hidden>
        <path
            fillRule="evenodd"
            d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.168 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
        />
    </svg>
);

interface Props {
    sectionKey: BillingStepKey;
    title: string;
    values: Record<string, any>;
    editing: boolean;
    hasErrors?: boolean;
    saving?: boolean;
    onEdit: () => void;
    onCancel: () => void;
    onSave: () => void;
    children?: React.ReactNode;
    // 读态底部附加内容（settings 的 rendering tab：+ Add another provider）
    readExtra?: React.ReactNode;
    // 只读视图的展示开关（向导 Review 专用提示）
    viewOpts?: SectionViewOpts;
}

// Review 卡片（原型 .ibbw-rev-card）：只读行展示，Edit 后原位展开该步骤表单（Cancel / Save changes）
export default function ReviewSection({
    sectionKey,
    title,
    values,
    editing,
    hasErrors,
    saving,
    onEdit,
    onCancel,
    onSave,
    children,
    readExtra,
    viewOpts,
}: Props) {
    return (
        <div className={cx(s.reviewSection, hasErrors && s.reviewSectionErrors)} data-section={sectionKey}>
            <div className={s.reviewSectionHeader}>
                <div className={s.reviewSectionTitle}>
                    {title}
                    {hasErrors && (
                        <span className={s.attentionBadge}>
                            <AttentionIcon />
                            Attention required
                        </span>
                    )}
                </div>
                {editing ? (
                    <div className={s.reviewEditActions}>
                        <Button onClick={onCancel} disabled={saving}>
                            Cancel
                        </Button>
                        <Button type="primary" onClick={onSave} loading={saving}>
                            Save changes
                        </Button>
                    </div>
                ) : (
                    <Button className={s.reviewEditBtn} onClick={onEdit}>
                        Edit
                    </Button>
                )}
            </div>

            {editing ? (
                <div className={s.reviewEditForm}>{children}</div>
            ) : (
                <>
                    {renderSectionView(sectionKey, values, viewOpts)}
                    {readExtra}
                </>
            )}
        </div>
    );
}
